export default status => {
  if (status === 'ACTIVE') {
    return '#e2e2e2';
  } if (status === 'PAID') {
    return '#ececff';
  } if (status === 'CANCELLED') {
    return '#e2e2e2';
  } if (status === 'DECLINED') {
    return '#e2e2e2';
  } if (status === 'EXPIRED') {
    return '#ee6972';
  } if (status === 'READY_TO_FUND') {
    return '#f6d87e';
  } return '#e2e2e2';
};
